import { BROADCAST_START_PROGRAM } from '../Types';

function startProgram() {
  return dispatch => dispatch({ type: BROADCAST_START_PROGRAM });
}

export default startProgram;
